// Accordion.js

var $ = require('jquery');

$(document).ready(function() {

    // Accessible Accordion
    // https://theadminbar.com/accessibility-weekly/accessible-accordions/
    // https://www.w3.org/WAI/ARIA/apg/patterns/accordion/examples/accordion/

    var button = $('.accordion .js-button');
    $('.accordion .item__content').hide().addClass('-setup');
    $('.accordion .js-button').attr('aria-expanded', false);

    button.each(function() {
        var open = false;

        $(this).on('click', function(){
            var content = $(this).parents('.layout__item').find('.item__content');

            if(open) {
                $(this).attr('aria-expanded', false);
                // content.addClass('-hide');
                toggleContent(content, false);
                open = false;

            } else {
                $(this).attr('aria-expanded', true);
                // content.removeClass('-hide');
                toggleContent(content, true);
                open = true;
            }
        });
    });
})


// - - - FUNCTION - - -


function toggleContent(content, open) { 
    content.show();
    var height = content[0].scrollHeight;
    
    if (open) { 
        content.animate({ 'max-height': height }, 500, function() {
            content.show();
        });

    } else { 
        content.animate({ 'max-height': 0 }, 500, function() {
            content.hide();
        });
    }  
}